import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const DirectionIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.45343 5.20894C8.71902 4.91679 9.14962 4.91679 9.41521 5.20894L10.7754 6.70513C11.041 6.99728 11.041 7.47095 10.7754 7.76309L9.41521 9.25928C9.14962 9.55143 8.71902 9.55143 8.45343 9.25928C8.18784 8.96713 8.18784 8.49347 8.45343 8.20132L8.65262 7.98221H7.57416C7.44895 7.98221 7.34746 8.09385 7.34746 8.23157V10.2265C7.34746 10.6396 7.04298 10.9746 6.66738 10.9746C6.29177 10.9746 5.98729 10.6396 5.98729 10.2265V8.23157C5.98729 7.26753 6.69775 6.48602 7.57416 6.48602H8.65262L8.45343 6.26691C8.18784 5.97476 8.18784 5.50109 8.45343 5.20894Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.58695 1.65733C8.7105 0.780888 7.2895 0.780889 6.41305 1.65733L1.65733 6.41305C0.780888 7.2895 0.780889 8.7105 1.65733 9.58695L6.41305 14.3427C7.2895 15.2191 8.7105 15.2191 9.58695 14.3427L14.3427 9.58695C15.2191 8.7105 15.2191 7.2895 14.3427 6.41305L9.58695 1.65733ZM7.47102 2.7153C7.76317 2.42315 8.23683 2.42315 8.52898 2.7153L13.2847 7.47102C13.5769 7.76317 13.5769 8.23683 13.2847 8.52898L8.52898 13.2847C8.23683 13.5769 7.76317 13.5769 7.47102 13.2847L2.7153 8.52898C2.42315 8.23683 2.42315 7.76317 2.7153 7.47102L7.47102 2.7153Z"
		></path>
	</svg>
))
